<!-- client\src\components\NewAquariumModal.vue -->
<template>
  <v-dialog v-model="modalStore.isNewAquariumModalVisible" persistent max-width="500px">
    <v-card>
      <v-card-title v-if="this.modalStore.newAquariumModalVerb === 'create'">
        Create A New Aquarium
      </v-card-title>

      <v-card-title v-if="this.modalStore.newAquariumModalVerb === 'edit'">
        Edit An Aquarium
      </v-card-title>

      <v-card-text>
        <v-form ref="newAquariumForm">
          <v-text-field
            v-if="this.modalStore.newAquariumModalMode === 'admin' || debugMode"
            v-model="newAquarium.user_id"
            label="User ID"
            :rules="[value => !!value || 'User ID is required']"
            :readonly="this.modalStore.newAquariumModalVerb === 'edit'"
            required
          />
          <v-text-field
            v-model="newAquarium.name"
            label="Name"
            :rules="[value => !!value || 'Name is required']"
            required
          />
          <v-text-field
            v-model="newAquarium.description"
            label="Description (optional)"
            :rules="[value => value.length <= 255 || 'Description must be less than 255 characters']"
          />
          <v-text-field
            v-if="this.modalStore.newAquariumModalMode === 'admin' || debugMode"
            v-model="newAquarium.image_url"
            label="Image URL"
            :rules="[value => !value || value.startsWith('http') || 'Image URL must start with http or https']"
          />
          <v-switch
            v-if="this.modalStore.newAquariumModalVerb === 'edit' && this.modalStore.newAquariumModalMode === 'admin'"
            v-model="newAquarium.active"
            label="Active"
            color="primary"
            :true-value="true"
            :false-value="false"
          />
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" text @click="close">Close</v-btn>
        <v-btn color="green darken-1" text @click="submit">Save</v-btn>
      </v-card-actions>
      
    </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios';
import { useAuthStore } from '@/store';
import { useModalStore } from '@/store';
import { usePopupStore } from '@/store';
import { ref, watchEffect } from 'vue';

export default {
  name: 'NewAquariumModal',
  setup() {
    const authStore = useAuthStore();
    const popupStore = usePopupStore();
    const modalStore = useModalStore();

    const newAquarium = ref({
      user_id: '',
      name: '',
      description: '',
      image_url: '',
      active: true, // <-- Add default
    });

    // Initialize newAquarium when the modal becomes visible
    watchEffect(() => {
      if (modalStore.isNewAquariumModalVisible) {
        newAquarium.value = {
          user_id: authStore.user?.id || '',
          name: '',
          description: '',
          image_url: '',
          active: true,
          ...modalStore.prefilledAquariumData, // Merge prefilled data
        };
      }
    });

    return {
      debugMode: false,
      authStore,
      popupStore,
      modalStore,
      newAquarium,
    };
  },
  methods: {
    close() {
      this.modalStore.closeNewAquariumModal();
    },
    async submit() {
      if (!this.newAquarium.name) {
        return;
      }
      
      if (this.modalStore.newAquariumModalVerb === 'create') {
        try {
          const response = await axios.post('/api/aquariums/', this.newAquarium);
          this.newAquarium = { user_id: '', name: '', description: '', image_url: '' };
          this.popupStore.setMessage('Aquarium Created', 'Happy reefing!', 'success');
          
          this.$eventBus.emit('aquarium-updated');
          this.close();
          
          if (this.modalStore.newAquariumModalMode === 'user') {
            this.$router.push({ name: 'Aquarium Detail', params: { id: response.data.id } });
          }
        } catch (error) {
          this.popupStore.setMessage('Error Creating Aquarium', error.response?.data?.message || error.message);
        }
      } else if (this.modalStore.newAquariumModalVerb === 'edit') {
        try {
          const response = await axios.put(`/api/aquariums/${this.newAquarium.id}`, this.newAquarium);
          this.popupStore.setMessage('Aquarium Edited', 'Your fish just got an upgrade!', 'success');

          console.log(this.$eventBus.all['aquarium-updated']); // mitt stores listeners in .all
          this.$eventBus.emit('aquarium-updated');
          this.close();
        } catch (error) {
          this.popupStore.setMessage('Error Updating Aquarium', error.response?.data?.message || error.message);
        }
      }
    },
  },
};
</script>
